module.exports = __webpack_public_path__ + "static/media/mobile-wireframe1.95045162.png";